import { useDispatch, useSelector } from 'react-redux';
import { agregarProducto as agregarProductoCarrito, quitarProducto as quitarProductoCarrito } from '../../redux/carrito/carritoSlice';
import { agregarProducto as agregarProductoMayorista, quitarProducto as quitarProductoMayorista } from '../../redux/carritoMayorista/carritoMayoristaSlice';
import { precioConDescuentoMayorista } from '../../utils/mayorista';

type UseHookParams = {
    producto: any
    mayorista?: boolean
}

const useHook = ({ producto, mayorista = false }: UseHookParams) => {
  const dispatch = useDispatch();
  const carrito = useSelector((state: any) => mayorista ? state.carritoMayorista.productos : state.carrito.productos);

  const productoEnCart = carrito.find((i: any) => i.producto.id == producto.id);
  const cantidadCurrent = productoEnCart?.cantidad || 0;

  const saveCarrito = (action: string) => {
    const productoAGuardar = mayorista ? {
      ...producto,
      attributes: {
        ...producto.attributes,
        precioFinal: precioConDescuentoMayorista(producto.attributes.precioFinal)
      }
    } : producto;

    const item = {
      cantidad: 1,
      producto: productoAGuardar
    };

    const agregarProducto = mayorista ? agregarProductoMayorista : agregarProductoCarrito;
    const quitarProducto = mayorista ? quitarProductoMayorista : quitarProductoCarrito;

    if (action == "inc") {
      dispatch(agregarProducto(item));
    }
    if (action == "dec") {
      dispatch(quitarProducto(item));
    }
  };

  const dec = () => {
    if (cantidadCurrent > 0) {
      saveCarrito("dec");
    }
  };

  const inc = () => {
    saveCarrito("inc");
  };

  return {
    cantidadCurrent,
    dec,
    inc,
  };
};

export default useHook;
